<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="mb-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline mb-0">{{labels.applicant}}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-autocomplete key="appSalutation" :items="salutationList" v-model="packageForm.applicant.appSalutation" :label="labels.appSalutation" item-text="label" item-value="value" data-vv-name="appSalutation" :data-vv-as="labels.appSalutation" :error-messages="errors.collect('appSalutation')" v-validate="'required'" @input="doSalutation"></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="appName" v-model="packageForm.applicant.appName" :label="labels.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="labels.appName" v-validate="'required|name|max:50'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="appNricPassport" v-uppercase="packageForm.applicant.appNricPassport" v-model="packageForm.applicant.appNricPassport" :label="labels.appNricPassport" :error-messages="errors.collect('appNricPassport')" data-vv-name="appNricPassport" :data-vv-as="labels.appNricPassport" v-validate="'alpha_num|max:20'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <cal-picker key="appDob" v-model="packageForm.applicant.appDob" :label="labels.appDob" :data-vv-as="labels.appDob" data-vv-name="appDob" :error-messages="errors.collect('appDob')"></cal-picker>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-radio-group key="appGender" v-model="packageForm.applicant.appGender" row :label="labels.appGender" :error-messages="errors.collect('appGender')" data-vv-name="appGender" :data-vv-as="labels.appGender">
                    <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.appOccupation" :label="labels.appOccupation" :error-messages="errors.collect('appOccupation')" data-vv-name="appOccupation" :data-vv-as="labels.appOccupation" v-validate="'required|entry|max:100'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.coyName" :label="labels.coyName" :error-messages="errors.collect('coyName')" data-vv-name="coyName" :data-vv-as="labels.coyName" v-validate="'required|name|max:50'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.coyName2" :label="labels.coyName2" :error-messages="errors.collect('coyName2')" data-vv-name="coyName2" :data-vv-as="labels.coyName2" v-validate="'name|max:50'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.coyRocUen" :label="labels.coyRocUen" :error-messages="errors.collect('coyRocUen')" data-vv-name="coyRocUen" :data-vv-as="labels.coyRocUen" v-validate="'entry|max:20'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.coyNature" :label="labels.coyNature" :error-messages="errors.collect('coyNature')" data-vv-name="coyNature" :data-vv-as="labels.coyNature" v-validate="'required|entry|max:128'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.appContact}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.appEmail" type="email" :label="labels.appEmail" :error-messages="errors.collect('appEmail')" data-vv-name="appEmail" :data-vv-as="labels.appEmail" v-validate="'required|email'" prepend-icon="mdi-email" hint="An email acknowledgement will be sent to this address" :persistent-hint="true"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.appMobileNo" v-int-mask="{intScale: 8}" type="tel" :label="labels.appMobileNo" :error-messages="errors.collect('appMobileNo')" data-vv-name="appMobileNo" :data-vv-as="labels.appMobileNo" :v-validate="{numeric:true}" hint="Mobile No. is required to receive SMS confirmation" :persistent-hint="true" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.appTelNo1" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo1" :error-messages="errors.collect('appTelNo1')" data-vv-name="appTelNo1" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.appTelNo2" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo2" :error-messages="errors.collect('appTelNo2')" data-vv-name="appTelNo2" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.appAddress}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.appAdd3" :label="labels.appAdd3" :error-messages="errors.collect('appAdd3')" data-vv-name="appAdd3" :data-vv-as="labels.appAdd3" prefix="#" v-validate="'unit_no|max:30'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.appPostalCode" :label="labels.appPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('appPostalCode')" data-vv-name="appPostalCode" :data-vv-as="labels.appPostalCode" v-validate="'required|numeric'" :loading="appPostalCodeLoading" @change="doAppAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.appAdd1" :label="labels.appAdd1" :error-messages="errors.collect('appAdd1')" data-vv-name="appAdd1" :data-vv-as="labels.appAdd1" v-validate="'required|entry|max:30'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.appAdd2" :label="labels.appAdd2" :error-messages="errors.collect('appAdd2')" data-vv-name="appAdd2" :data-vv-as="labels.appAdd2" v-validate="'required|entry|max:255'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.appAdd4" :label="labels.appAdd4" :error-messages="errors.collect('appAdd4')" data-vv-name="appAdd4" :data-vv-as="labels.appAdd4" v-validate="'entry|max:255'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.mailAddress}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="packageForm.applicant.mailAdd" :label="labels.mailAdd" data-vv-name="mailAdd" :data-vv-as="labels.mailAdd" :error-messages="errors.collect('mailAdd')" @change="doMailAdd" hide-details></v-checkbox>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.mailAdd3" :label="labels.mailAdd3" :error-messages="errors.collect('mailAdd3')" data-vv-name="mailAdd3" :data-vv-as="labels.mailAdd3" prefix="#" v-validate="'entry|max:30'" :readonly="packageForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.mailPostalCode" :label="labels.mailPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('mailPostalCode')" data-vv-name="mailPostalCode" :readonly="packageForm.applicant.mailAdd" :data-vv-as="labels.mailPostalCode" v-validate="'numeric'" :loading="mailPostalCodeLoading" @change="doMailAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.mailAdd1" :label="labels.mailAdd1" :error-messages="errors.collect('mailAdd1')" data-vv-name="mailAdd1" :data-vv-as="labels.mailAdd1" v-validate="'entry|max:30'" :readonly="packageForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.mailAdd2" :label="labels.mailAdd2" :error-messages="errors.collect('mailAdd2')" data-vv-name="mailAdd2" :data-vv-as="labels.mailAdd2" v-validate="'entry|max:255'" :readonly="packageForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.applicant.mailAdd4" :label="labels.mailAdd4" :error-messages="errors.collect('mailAdd4')" data-vv-name="mailAdd4" :data-vv-as="labels.mailAdd4" v-validate="'entry|max:255'" :readonly="packageForm.applicant.mailAdd"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_PACKAGE_APPLICANT } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { salutation, gender } from '@/const/underwriting'
import toDate from 'date-fns/toDate'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        applicant: 'Applicant',
        appName: 'Name as in NRIC/Passport*',
        appSalutation: 'Salutation*',
        appNricPassport: 'NRIC/Passport',
        appDob: 'Date of Birth',
        appGender: 'Gender',
        appOccupation: 'Designation*',
        appAddress: 'Applicant Address',
        mailAddress: 'Mailing Address',
        appAdd1: 'Block/House No.*',
        appAdd2: 'Street Name*',
        appAdd3: 'Unit No.',
        appAdd4: 'Building Name',
        appPostalCode: 'Postal Code*',
        mailAdd: 'Same as Applicant Address',
        mailAdd1: 'Block/House No.',
        mailAdd2: 'Street Name',
        mailAdd3: 'Unit No.',
        mailAdd4: 'Building Name',
        mailPostalCode: 'Postal Code',
        appContact: 'Contacts',
        appEmail: 'Email*',
        appMobileNo: 'Mobile No.',
        appTelNo1: 'Home No.',
        appTelNo2: 'Office No',
        coyName: 'Name of Company*',
        coyName2: 'Name of Company 2',
        coyRocUen: 'ROC/UEN',
        coyNature: 'Nature of Business*'
      },
      packageForm: {
        applicant: {
          appSalutation: undefined,
          appName: undefined,
          appNricPassport: undefined,
          appDob: undefined,
          appGender: undefined,
          appOccupation: undefined,
          appEmail: undefined,
          appMobileNo: undefined,
          appTelNo1: undefined,
          appTelNo2: undefined,
          appPostalCode: undefined,
          appAdd1: undefined,
          appAdd2: undefined,
          appAdd3: undefined,
          appAdd4: undefined,
          mailAdd: undefined,
          mailPostalCode: undefined,
          mailAdd1: undefined,
          mailAdd2: undefined,
          mailAdd3: undefined,
          mailAdd4: undefined,
          coyName: undefined,
          coyName2: undefined,
          coyRocUen: undefined,
          coyNature: undefined
        }
      },
      appPostalCodeLoading: false,
      mailPostalCodeLoading: false
    }
  },
  computed: {
    globalForm() {
      return this.$store.state.agency.quotation.packageForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  watch: {
    'packageForm.applicant.appAdd1': function (value) {
      if (this.packageForm.applicant.mailAdd) {
        this.packageForm.applicant.mailAdd1 = value
      }
      if (this.packageForm.riskAdd) {
        this.packageForm.riskAdd1 = value
      }
    },
    'packageForm.applicant.appAdd2': function (value) {
      if (this.packageForm.applicant.mailAdd) {
        this.packageForm.applicant.mailAdd2 = value
      }
      if (this.packageForm.riskAdd) {
        this.packageForm.riskAdd2 = value
      }
    },
    'packageForm.applicant.appAdd3': function (value) {
      if (this.packageForm.applicant.mailAdd) {
        this.packageForm.applicant.mailAdd3 = value
      }
      if (this.packageForm.riskAdd) {
        this.packageForm.riskAdd3 = value
      }
    },
    'packageForm.applicant.appAdd4': function (value) {
      if (this.packageForm.applicant.mailAdd) {
        this.packageForm.applicant.mailAdd4 = value
      }
      if (this.packageForm.riskAdd) {
        this.packageForm.riskAdd4 = value
      }
    },
    'packageForm.applicant.appPostalCode': function (value) {
      if (this.packageForm.applicant.mailAdd) {
        this.packageForm.applicant.mailPostalCode = value
      }
      if (this.packageForm.riskAdd) {
        this.packageForm.riskPostalCode = value
      }
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      // Applicant
      const { applicant } = this.globalCommonForm
      this.packageForm.applicant.appSalutation = applicant.appSalutation
      this.packageForm.applicant.appName = applicant.appName
      this.packageForm.applicant.appGender = applicant.appGender
      this.packageForm.applicant.appNricPassport = applicant.appNricPassport
      if (applicant.appDob) {
        this.packageForm.applicant.appDob = toDate(applicant.appDob)
      }
      this.packageForm.applicant.appOccupation = applicant.appOccupation
      this.packageForm.applicant.appEmail = applicant.appEmail
      this.packageForm.applicant.appMobileNo = applicant.appMobileNo
      this.packageForm.applicant.appTelNo1 = applicant.appTelNo1
      this.packageForm.applicant.appTelNo2 = applicant.appTelNo2
      this.packageForm.applicant.appPostalCode = applicant.appPostalCode
      this.packageForm.applicant.appAdd1 = applicant.appAdd1
      this.packageForm.applicant.appAdd2 = applicant.appAdd2
      this.packageForm.applicant.appAdd3 = applicant.appAdd3
      this.packageForm.applicant.appAdd4 = applicant.appAdd4
      this.packageForm.applicant.mailAdd = applicant.mailAdd
      this.packageForm.applicant.mailPostalCode = applicant.mailPostalCode
      this.packageForm.applicant.mailAdd1 = applicant.mailAdd1
      this.packageForm.applicant.mailAdd2 = applicant.mailAdd2
      this.packageForm.applicant.mailAdd3 = applicant.mailAdd3
      this.packageForm.applicant.mailAdd4 = applicant.mailAdd4
      this.packageForm.applicant.coyName = applicant.coyName
      this.packageForm.applicant.coyName2 = applicant.coyName2
      this.packageForm.applicant.coyRocUen = applicant.coyRocUen
      this.packageForm.applicant.coyNature = applicant.coyNature
    },
    doSalutation() {
      if (this.packageForm.applicant.appSalutation === 'MR') {
        this.packageForm.applicant.appGender = 'M'
      } else if (this.packageForm.applicant.appSalutation === 'MS' || this.packageForm.applicant.appSalutation === 'MDM' || this.packageForm.applicant.appSalutation === 'MRS') {
        this.packageForm.applicant.appGender = 'F'
      } else {
        if (!this.packageForm.applicant.appGender || this.packageForm.applicant.appGender === null) {
          this.packageForm.applicant.appGender = 'M'
        }
      }
    },
    async doAppAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.appPostalCodeLoading = true
          const expand = {
            postCode: this.packageForm.applicant.appPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.packageForm.applicant.appAdd1 = data.add1
            this.packageForm.applicant.appAdd2 = data.add2
            this.packageForm.applicant.appAdd4 = data.add4
          }
          this.appPostalCodeLoading = false
        } catch (err) {
          this.appPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doMailAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.mailPostalCodeLoading = true
          const expand = {
            postCode: this.packageForm.applicant.mailPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.packageForm.applicant.mailAdd1 = data.add1
            this.packageForm.applicant.mailAdd2 = data.add2
            this.packageForm.applicant.mailAdd4 = data.add4
          }
          this.mailPostalCodeLoading = false
        } catch (err) {
          this.mailPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doMailAdd() {
      this.packageForm.applicant.mailAdd1 = this.packageForm.applicant.appAdd1
      this.packageForm.applicant.mailAdd2 = this.packageForm.applicant.appAdd2
      this.packageForm.applicant.mailAdd3 = this.packageForm.applicant.appAdd3
      this.packageForm.applicant.mailAdd4 = this.packageForm.applicant.appAdd4
      this.packageForm.applicant.mailPostalCode = this.packageForm.applicant.appPostalCode
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'packageQuotePlans' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.packageForm.applicant.appMobileNo && this.packageForm.applicant.appMobileNo !== '') ||
            (this.packageForm.applicant.appTelNo1 && this.packageForm.applicant.appTelNo1 !== '') ||
            (this.packageForm.applicant.appTelNo2 && this.packageForm.applicant.appTelNo2 !== '')) {
            this.$store.commit('QUOTE_PACKAGE_APPLICANT', this.packageForm.applicant)
            this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
            this.$router.push({ name: 'packageQuoteRisk' })
          } else {
            this.promptFieldCheck()
            this.errorMessage('At least one of the contact number is required')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.commit(QUOTE_PACKAGE_APPLICANT, this.packageForm.applicant)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 3) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
</style>
